import { getUser } from "@faire/retailer-visitor-shared/serialized-data/getUser";
import { useCurrencyStore } from "@faire/web--source/common/currency/CurrencyStore";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import logout from "@faire/web-api--source/endpoints/www/api/user/logout/post";
import { useQuery as useUserQuery } from "@faire/web-api--source/endpoints/www/api/user/userToken/get-hooks";
import { useCallback } from "react";

export function useUser() {
  const serializedUser = getUser();
  const { setCurrency } = useCurrencyStore(["setCurrency"]);

  const { data: user, refetch } = useUserQuery(serializedUser?.token ?? "", {
    enabled: !!serializedUser?.token,
    initialData: serializedUser,
    refetchOnMount: false,
  });

  // TODO: (@Jadesida) migrate patch user later on
  //   const patchUser = useCallback((userPartial: Partial<IUser>) => {
  //     setUser((prev) =>
  //       prev
  //         ? {
  //             ...prev,
  //             ...userPartial,
  //           }
  //         : undefined
  //     );
  //   }, []);

  const logOut = useCallback(
    async (dest?: string) => {
      await logout();
      setCurrency(undefined);
      getLocationOrThrow().href = dest ? dest : faireBaseUrl();
    },
    [setCurrency]
  );

  return {
    user,
    fetchUser: refetch,
    logOut,
  };
}
